import {
    TASK_GET_ALL,
    TASK_SET_FILTERS,
    TASK_CLEAR_FILTERS,
    TASK_SET_STATE,
    TASK_PAGE_RESET,
    TASK_SET_LOADING,
    TASK_SET_ERROR,
    TASK_CREATE,
    TASK_CREATE_SUCCESS,
    TASK_CREATE_FAILURE,
    TASK_SET_SELECTED_TASK,
    TASK_GET_STATISTICS,
    TASK_SET_EMPLOYEES // Add this import
} from "./TaskActionType";

// Initial state
const initialState = {
    tasks: [],
    employees: [], // Add employees array to state
    filteredTasks: [],
    selectedTask: null,
    filters: {
        EmployeeCode: null
    },
    statistics: {
        totalTasks: 0,
        completedTasks: 0,
        inProgressTasks: 0,
        overdueTasks: 0,
        averageProgress: 0,
        tasksByStatus: {},
        tasksByPriority: {}
    },
    loading: false,
    error: null,
    createStatus: {
        loading: false,
        success: false,
        error: null,
        response: null
    },
    pagination: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0
    }
};

const TaskReducer = (state = initialState, action: any) => {
    switch (action.type) {
        
        case TASK_GET_ALL:
            return {
                ...state,
                tasks: action.payload || [],
                filteredTasks: action.payload || [],
                pagination: {
                    ...state.pagination,
                    totalItems: action.payload?.length || 0,
                    totalPages: Math.ceil((action.payload?.length || 0) / state.pagination.itemsPerPage)
                },
                error: null
            };
            
        case TASK_SET_EMPLOYEES: // Add this case to handle employees
            return {
                ...state,
                employees: action.payload || []
            };
            
        case TASK_SET_FILTERS:
            // Apply filters to tasks
            const filtered = state.tasks.filter((task: any) => {
                let matches = true;
                
                // Filter by EmployeeCode if set
                if (action.payload?.EmployeeCode) {
                    matches = matches && (
                        task.TaskGivenTo === action.payload.EmployeeCode ||
                        task.TaskGivenBy === action.payload.EmployeeCode
                    );
                }
                
                return matches;
            });
            
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload
                },
                filteredTasks: filtered,
                pagination: {
                    ...state.pagination,
                    currentPage: 1,
                    totalItems: filtered.length,
                    totalPages: Math.ceil(filtered.length / state.pagination.itemsPerPage)
                }
            };
            
        case TASK_CLEAR_FILTERS:
            return {
                ...state,
                filters: {
                    EmployeeCode: null
                },
                filteredTasks: state.tasks,
                pagination: {
                    ...state.pagination,
                    currentPage: 1,
                    totalItems: state.tasks.length,
                    totalPages: Math.ceil(state.tasks.length / state.pagination.itemsPerPage)
                }
            };
            
        case TASK_SET_SELECTED_TASK:
            return {
                ...state,
                selectedTask: action.payload
            };
            
        case TASK_GET_STATISTICS:
            return {
                ...state,
                statistics: {
                    ...state.statistics,
                    ...action.payload
                }
            };
            
        case TASK_SET_STATE:
            return {
                ...state,
                ...action.payload
            };
            
        case TASK_SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };
            
        case TASK_SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
            
        case TASK_CREATE:
            return {
                ...state,
                createStatus: {
                    loading: true,
                    success: false,
                    error: null,
                    response: null
                }
            };
            
        case TASK_CREATE_SUCCESS:
            return {
                ...state,
                createStatus: {
                    loading: false,
                    success: true,
                    error: null,
                    response: action.payload
                },
                tasks: [...state.tasks, action.payload],
                filteredTasks: [...state.filteredTasks, action.payload]
            };
            
        case TASK_CREATE_FAILURE:
            return {
                ...state,
                createStatus: {
                    loading: false,
                    success: false,
                    error: action.payload,
                    response: null
                }
            };
            
        case TASK_PAGE_RESET:
            return {
                ...initialState
            };
            
        default:
            return state;
    }
};

export default TaskReducer;